import { createFieldset } from './fieldset';

export default {
  title: 'Aggiungi tipologia Bowl',
  elements: [
    {
      type: 'createForm',
      config: {
        actions: {
          save: {
            endpoint: 'bowl-types',
            method: 'POST'
          }
        },
        fieldsets: [createFieldset]
      }
    }
  ]
};
